var map = {
	"./24h.svg": [
		79565,
		9565
	],
	"./accessibility.svg": [
		89666,
		7572
	],
	"./accident.svg": [
		56721,
		6721
	],
	"./alone.svg": [
		36819,
		6819
	],
	"./arrow-left-big.svg": [
		4461,
		4461
	],
	"./arrow-left.svg": [
		48004,
		8004
	],
	"./arrow-right-big.svg": [
		93052,
		3052
	],
	"./arrow-right.svg": [
		23624,
		3624
	],
	"./assistance.svg": [
		28295,
		8295
	],
	"./banker.svg": [
		13840,
		3840
	],
	"./boat.svg": [
		58609,
		8609
	],
	"./burger.svg": [
		47269,
		7269
	],
	"./business.svg": [
		61214,
		1214
	],
	"./calendar.svg": [
		28306,
		8306
	],
	"./car-and-moto.svg": [
		43915,
		3915
	],
	"./car-insurance.svg": [
		75724,
		5724
	],
	"./car-protection.svg": [
		61112,
		1112
	],
	"./car.svg": [
		88403,
		8403
	],
	"./check.svg": [
		62914,
		2914
	],
	"./chevron-down.svg": [
		57556,
		7556
	],
	"./chevron-left.svg": [
		96109,
		6109
	],
	"./chevron-right.svg": [
		99792,
		9792
	],
	"./chevron-up.svg": [
		38071,
		8071
	],
	"./clarity.svg": [
		62458,
		2458
	],
	"./clear.svg": [
		6469,
		6469
	],
	"./close.svg": [
		88765,
		8765
	],
	"./comment.svg": [
		52037,
		2037
	],
	"./consultant-men.svg": [
		12097,
		2097
	],
	"./consultant-women.svg": [
		76678,
		6678
	],
	"./contract.svg": [
		15785,
		5785
	],
	"./control.svg": [
		24971,
		4971
	],
	"./custom-content.svg": [
		80875,
		875
	],
	"./descriptive-icons.svg": [
		27273,
		7273
	],
	"./desktop.svg": [
		10717,
		717
	],
	"./dialogue.svg": [
		37598,
		7598
	],
	"./diamond.svg": [
		67209,
		7209
	],
	"./direction.svg": [
		22061,
		2061
	],
	"./document-2.svg": [
		66330,
		6330
	],
	"./document.svg": [
		66597,
		6597
	],
	"./double-check.svg": [
		14347,
		4347
	],
	"./download.svg": [
		80470,
		470
	],
	"./email.svg": [
		41273,
		1273
	],
	"./employees.svg": [
		81845,
		1845
	],
	"./euro.svg": [
		56018,
		6018
	],
	"./eye.svg": [
		82767,
		2767
	],
	"./facebook.svg": [
		36596,
		6596
	],
	"./family.svg": [
		90900,
		900
	],
	"./filter-selected.svg": [
		13757,
		3757
	],
	"./filter.svg": [
		64283,
		4283
	],
	"./forward.svg": [
		67517,
		7517
	],
	"./funding.svg": [
		19365,
		9365
	],
	"./growth.svg": [
		8648,
		8648
	],
	"./health.svg": [
		22078,
		2078
	],
	"./heart.svg": [
		51314,
		1314
	],
	"./heritage.svg": [
		77470,
		7470
	],
	"./hierarchy.svg": [
		99516,
		9516
	],
	"./house.svg": [
		89721,
		9721
	],
	"./info.svg": [
		74017,
		4017
	],
	"./instagram.svg": [
		57716,
		7716
	],
	"./instruments.svg": [
		69897,
		9897
	],
	"./investment-ingenuity.svg": [
		58884,
		8884
	],
	"./investments.svg": [
		75703,
		5703
	],
	"./laptop-and-smartphone.svg": [
		63926,
		3926
	],
	"./lifestyle-protection.svg": [
		72884,
		2884
	],
	"./like.svg": [
		99428,
		9428
	],
	"./linkedin.svg": [
		66510,
		6510
	],
	"./logo-assicurazioni-dark.svg": [
		27314,
		7314
	],
	"./logo-assicurazioni-light.svg": [
		251,
		251
	],
	"./logo-brandmark-dark.svg": [
		32903,
		2903
	],
	"./logo-brandmark-light.svg": [
		80272,
		272
	],
	"./logo-mixed-dark.svg": [
		85248,
		5248
	],
	"./logo-mixed-light.svg": [
		69482,
		9482
	],
	"./logo-unipol-color.svg": [
		75227,
		5227
	],
	"./logo-unipol-dark.svg": [
		55115,
		5115
	],
	"./logo-unipol-light.svg": [
		13799,
		3799
	],
	"./logo-vita-dark.svg": [
		31743,
		1743
	],
	"./logo-vita-international-light.svg": [
		53025,
		3025
	],
	"./logo-vita-light.svg": [
		14043,
		4043
	],
	"./mail.svg": [
		22211,
		2211
	],
	"./map-2.svg": [
		26418,
		6418
	],
	"./map.svg": [
		19973,
		9973
	],
	"./marker.svg": [
		71674,
		1674
	],
	"./minus.svg": [
		62313,
		2313
	],
	"./money.svg": [
		85352,
		5352
	],
	"./more-info.svg": [
		60974,
		974
	],
	"./motorbike.svg": [
		97116,
		7116
	],
	"./myquote.svg": [
		24763,
		4763
	],
	"./page-error.svg": [
		44798,
		4798
	],
	"./pause.svg": [
		56711,
		6711
	],
	"./pension.svg": [
		94333,
		4333
	],
	"./people-centred.svg": [
		51489,
		1489
	],
	"./philanthropy-2.svg": [
		42044,
		2044
	],
	"./philanthropy.svg": [
		13750,
		3750
	],
	"./phone-in.svg": [
		71575,
		1575
	],
	"./phone.svg": [
		56110,
		6110
	],
	"./play.svg": [
		9859,
		9990
	],
	"./plus.svg": [
		52745,
		2745
	],
	"./protection-2.svg": [
		39325,
		9325
	],
	"./protection-house.svg": [
		76622,
		6622
	],
	"./protection.svg": [
		3400,
		3400
	],
	"./qa.svg": [
		82465,
		2465
	],
	"./real-estate.svg": [
		7854,
		7854
	],
	"./remove.svg": [
		68067,
		8067
	],
	"./reserved-area.svg": [
		29525,
		9525
	],
	"./ribbon.svg": [
		49666,
		9666
	],
	"./savings.svg": [
		57042,
		7042
	],
	"./search.svg": [
		8686,
		8686
	],
	"./security.svg": [
		86713,
		6713
	],
	"./send.svg": [
		64691,
		4691
	],
	"./settings.svg": [
		61057,
		1057
	],
	"./share-box.svg": [
		83244,
		3244
	],
	"./smartphone.svg": [
		13237,
		3237
	],
	"./social-impact-investments.svg": [
		11913,
		1913
	],
	"./specialists.svg": [
		67836,
		7836
	],
	"./survey.svg": [
		58761,
		8761
	],
	"./sustainability.svg": [
		68603,
		8603
	],
	"./tailored.svg": [
		96061,
		6061
	],
	"./target-mountain.svg": [
		93207,
		3207
	],
	"./target.svg": [
		63458,
		3458
	],
	"./thief.svg": [
		93408,
		3408
	],
	"./together-2.svg": [
		13956,
		3956
	],
	"./together.svg": [
		52780,
		2780
	],
	"./traditional-investments.svg": [
		91593,
		1593
	],
	"./trash.svg": [
		31041,
		1041
	],
	"./trend-down.svg": [
		38218,
		8218
	],
	"./trend-unchanged.svg": [
		60481,
		481
	],
	"./trend-up.svg": [
		56567,
		6567
	],
	"./trend.svg": [
		92792,
		2792
	],
	"./twitter.svg": [
		68407,
		8407
	],
	"./user.svg": [
		93030,
		3030
	],
	"./values.svg": [
		88888,
		8888
	],
	"./vehicles.svg": [
		96405,
		6405
	],
	"./warning.svg": [
		503,
		503
	],
	"./whatsapp.svg": [
		99469,
		9469
	],
	"./work.svg": [
		34474,
		4474
	],
	"./youtube.svg": [
		74895,
		4895
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 817;
module.exports = webpackAsyncContext;